export enum TodoTypeEnum {
  ActiveConfirmation = 'ActiveConfirmation',
  PassiveConfirmation = 'PassiveConfirmation',
  HandleRejection = 'HandleRejection',
  Signature = 'Signature'
}
